import { Provider, EnvironmentProviders } from "@angular/core";
import {
  CONFIG,
  APP_NAME,
  APP_VERSION,
  UserTrackingService,
  ScreenTrackingService,
} from "@angular/fire/compat/analytics";
import type { GtagConfigParams } from "firebase/analytics";
import { version } from "./build-version";
import type { FirebaseOptions } from "firebase/app";

/** Common configuration for Firebase */
export const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyDAEINRq58_VIqZaRi1x7ets16AWoKkeeg",
  authDomain: "organic-chem-app.firebaseapp.com",
  databaseURL: "https://organic-chem-app.firebaseio.com",
  projectId: "organic-chem-app",
  storageBucket: "organic-chem-app.appspot.com",
  messagingSenderId: "6350727821",
  appId: "1:6350727821:web:5f6f85acfc06cbbcb490c4",
  measurementId: "G-3KZKRYKBCD",
};

/** @see {@link https://firebase.google.com/docs/reference/js/analytics.gtagconfigparams.md#properties} */
export const analyticsGtagConfig: GtagConfigParams = {
  /** If set to false, disables all advertising personalization with gtag.js.  */
  allow_ad_personalization_signals: false,
  /** If set to false, disables all advertising features with gtag.js. */
  allow_google_signals: false,
  /** Whether or not a page view should be sent. If set to true (default), a page view is automatically sent upon initialization of analytics. */
  send_page_view: false,
};

export const analyticsProvidersCommon: Array<Provider | EnvironmentProviders> =
  [
    /* AngularFireAnalytics automatic user and screen tracking */
    UserTrackingService,
    ScreenTrackingService,

    /* AngularFireAnalytics configuration */
    {
      provide: CONFIG,
      useValue: analyticsGtagConfig,
    },
    { provide: APP_NAME, useValue: "org.onlea.chemistry.spectroscopy" },
    {
      provide: APP_VERSION,
      useValue: version.buildVersion ?? "[dev-build-no-version]",
    },
  ];
